export default {
  region: {
    RegionName: '区域名称',
    RegionId: '区域编码',
    ParentId: '上级区域编码',
    ParentName: '上级区域名称',
    DealerName: '客户名称',
    Region: '所属地区',
    NewRegion: '新增区域',
    Remark: '备注',
    ModifyAreaInformation: '修改区域信息',
    No: '序号',
    Code: '客户编号',
    Operation: '操作',
    Edit: '编辑',
    // 组件国际化内容
    RegionSelect: '区域选择',

  }
}



// WEBPACK FOOTER //
// ./src/i18n/lang/cn/cmc/region.js